import ViewBoilerplate from "./ViewBoilerplate";

export default ViewBoilerplate;